/**
 * 번들 타일 키트 — chatgpt.com 추론 '매우 높음' 한 채팅에서 뽑은 던전 키트 (2026-09-04).
 * 텍스처는 768², 프롭은 768² 흰 배경. MapForge 팔레트와 TerrainForge 스플랫 층이 같은 목록을 본다:
 *   id 가 `tex-<층>` 이면 지형 층 후보, `heightmap` 이면 하이트맵.
 */
import type { TileKind } from './kit.ts';
import floorDungeon from '../../assets/kit/floor-dungeon.webp';
import wallDungeon from '../../assets/kit/wall-dungeon.webp';
import texGrass from '../../assets/kit/tex-grass.webp';
import texRock from '../../assets/kit/tex-rock.webp';
import texSnow from '../../assets/kit/tex-snow.webp';
import propChest from '../../assets/kit/prop-chest.webp';
import propPillar from '../../assets/kit/prop-pillar.webp';
import propBarrel from '../../assets/kit/prop-barrel.webp';
import propTorch from '../../assets/kit/prop-torch.webp';
import propDeadtree from '../../assets/kit/prop-deadtree.webp';

export interface KitItem { id: string; label: string; kind: TileKind; url: string }

export const KIT_GALLERY: KitItem[] = [
  { id: 'floor-dungeon', label: '던전 바닥 (잉걸 균열)', kind: 'floor', url: floorDungeon },
  { id: 'wall-dungeon', label: '던전 벽 (룬 벽돌)', kind: 'wall', url: wallDungeon },
  { id: 'tex-grass', label: '풀밭', kind: 'floor', url: texGrass },
  { id: 'tex-rock', label: '바위 절벽', kind: 'wall', url: texRock },
  { id: 'tex-snow', label: '눈밭', kind: 'floor', url: texSnow },
  { id: 'prop-chest', label: '보물상자', kind: 'prop', url: propChest },
  { id: 'prop-pillar', label: '부서진 기둥', kind: 'prop', url: propPillar },
  { id: 'prop-barrel', label: '나무통', kind: 'prop', url: propBarrel },
  { id: 'prop-torch', label: '벽 횃불', kind: 'prop', url: propTorch },
  { id: 'prop-deadtree', label: '고사목', kind: 'prop', url: propDeadtree },
];
